import { gql } from '@apollo/client';

export const ASSIGN_USERS_TO_ACTIVITY = gql`
  mutation AssignUsersToActivity($input: AssignUsersToActivityInput!) {
    activity: assignUsersToActivity(input: $input) {
      id
    }
  }
`;
